<div class="grid items-end lg:grid-cols-12">
  <div class="lg:col-span-4 xl:col-span-3">
    <app-public-box-search-panel
      (phraseChangeEvent)="handlePhraseChangeEvent($event)" />
  </div>

  <div class="lg:col-span-4 xl:col-span-6"></div>

  <div class="lg:col-span-4 xl:col-span-3">
    <app-public-box-sort-panel
      (sortTypeChange)="handleSortTypeChange($event)" />
  </div>
</div>

<div class="grid gap-12 lg:grid-cols-12">
  <div class="lg:col-span-4 xl:col-span-3">
    <app-public-box-categories
      (chooseCategoryEvent)="handleChooseCategoryEvent()" />
  </div>

  <div class="lg:col-span-8 xl:col-span-9">
    @if (boxes$ | async; as boxes) {
      <div class="grid gap-6 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3">
        @for (box of boxes; track box.id) {
          <app-public-box-tile
            [date]="box.publishedAt"
            [imageAlt]="box.imageAlt"
            [imageSrc]="box.imageSrc"
            [name]="box.name"
            [rating]="box.rating"
            [slug]="box.slug"
            [availability]="box.sales.availability"
            [votes]="box.votes" />
        }
      </div>
    } @else {
      <div class="flex min-h-72 w-full items-center justify-center">
        <app-spinner-filled />
      </div>
    }
  </div>
</div>
